import { useState, type FormEvent } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { Button } from '../components/Button';
import { Callout } from '../components/Callout';
import { Marca } from '../components/Marca';
import { Screen } from '../components/Screen';
import { TextField } from '../components/TextField';
import { firebaseConfigurado } from '../lib/firebase';
import { mensajeErrorAuth } from '../lib/erroresAuth';

export function LoginScreen() {
  const { user, cargando, iniciarSesion } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (user && !cargando) {
    const destino =
      (location.state as { from?: string } | null)?.from ?? '/';
    return <Navigate to={destino} replace />;
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!firebaseConfigurado) return;
    setError(null);
    setEnviando(true);
    try {
      await iniciarSesion(email, password);
    } catch (err) {
      setError(mensajeErrorAuth(err, 'No se pudo iniciar sesión. Intenta de nuevo.'));
      setEnviando(false);
    }
  }

  return (
    <Screen centrado>
      <div className="space-y-8 rounded-3xl border border-borde bg-white p-10 shadow-sm">
        <Marca className="h-28" />

        <form id="form-login" className="space-y-4" onSubmit={onSubmit} noValidate>
          <TextField
            label="Correo"
            labelOculta
            placeholder="Correo"
            className="placeholder:uppercase placeholder:tracking-wide"
            type="email"
            inputMode="email"
            autoComplete="username"
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck={false}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Contraseña"
            labelOculta
            placeholder="Contraseña"
            className="placeholder:uppercase placeholder:tracking-wide"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <Callout tono="error">{error}</Callout>}
          {!firebaseConfigurado && (
            <Callout tono="alerta">
              Falta configurar el proyecto de Firebase. Copia{' '}
              <code>frontend/.env.example</code> a <code>.env.local</code> y rellena los valores.
              Ver README.
            </Callout>
          )}
        </form>

        <p className="text-center text-sm text-texto/60">
          ¿Eres staff de puerta?{' '}
          <Link to="/login/staff" className="font-medium text-navy underline underline-offset-2">
            Entra con tu código
          </Link>
        </p>

        <Button
          type="submit"
          form="form-login"
          bloque
          grande
          redondeoCompleto={false}
          cargando={enviando}
          disabled={!firebaseConfigurado}
          className="uppercase tracking-wide"
        >
          Iniciar sesión
        </Button>

        <p className="text-center text-xs uppercase tracking-wide text-texto/40">
          © {new Date().getFullYear()} CIEN eventos®.
          <br />
          Todos los derechos reservados.
        </p>
      </div>
    </Screen>
  );
}
